export default {
  title: "计算模板",
  filter: {
    name: "模板名称",
    namePlaceholder: "请输入模板名称",
    type: "模板类型",
    typePlaceholder: "请选择模板类型",
  },
  table: {
    name: "模板名称",
    type: "类型",
    createdAt: "创建时间",
    actions: "操作",
    single: "单次计算",
    batch: "批量计算",
  },
  action: {
    edit: "编辑名称",
    use: "使用",
  },
  modal: {
    editTitle: "编辑模板名称",
    nameLabel: "模板名称",
    namePlaceholder: "请输入模板名称",
    nameRequired: "请输入模板名称",
  },
  deleteConfirm: {
    title: "删除模板",
    content: "确定要删除此模板吗？",
  },
  message: {
    fetchFailed: "获取模板列表失败",
    updateSuccess: "模板名称更新成功",
    updateFailed: "更新失败",
    deleteSuccess: "模板删除成功",
  },
};
